import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchArgentinianHeadlines } from '../features/Articles';
import ArticleCard from './ArticleCard';
import ArticleCardSkeleton from './ArticleCardSkeleton';

const Headlines = () => {
  const dispatch = useDispatch();
  const {
    argentinianHeadlines,
    argentinianHeadlineLoading,
    argentinianHeadlineError,
  } = useSelector((state) => state.articles);

  useEffect(() => {
    dispatch(fetchArgentinianHeadlines());
  }, [dispatch]);

  if (argentinianHeadlineError) {
    return <div>Error loading data.</div>;
  }

  return (
    <div className="flex flex-col sm:grid grid-cols-3 gap-5 p-5">
      {argentinianHeadlineLoading ? (
        <>
          <ArticleCardSkeleton />
          <ArticleCardSkeleton />
          <ArticleCardSkeleton />
        </>
      ) : (
        argentinianHeadlines.map((headline, index) => (
          <ArticleCard
            author={headline.author}
            section={headline.section}
            articleTitle={headline.articleTitle}
            articleUrl={headline.articleUrl}
            imgUrl={headline.imgUrl}
            id={headline._id}
          />
        ))
      )}
    </div>
  );
};

export default Headlines;
